export default "__VITE_ASSET__DdtVE1r8__"